import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4 text-foreground/80" />
        ),
        info: (
          <InfoIcon className="size-4 text-foreground/80" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4 text-foreground/80" />
        ),
        error: (
          <OctagonXIcon className="size-4 text-foreground/80" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin text-foreground/80" />
        ),
      }}
      style={
        {
          "--normal-bg": "color-mix(in oklab, var(--card) 94%, var(--background) 6%)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "calc(var(--radius) * 1.6)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            "cn-toast rounded-[calc(var(--radius)*1.6)] border border-border/80 bg-card/95 px-4 py-3 text-foreground shadow-[0_12px_32px_rgba(15,23,42,0.08)] backdrop-blur supports-[backdrop-filter]:bg-card/90",
          title: "text-sm font-medium text-foreground",
          description: "text-sm leading-6 text-muted-foreground",
          icon: "text-foreground/80",
          closeButton:
            "border-border/80 bg-background/80 text-muted-foreground hover:bg-muted hover:text-foreground",
          actionButton:
            "h-9 rounded-[calc(var(--radius)*1.2)] bg-foreground px-3 text-sm font-medium text-background hover:bg-foreground/90",
          cancelButton:
            "h-9 rounded-[calc(var(--radius)*1.2)] border border-border bg-background text-sm font-medium text-foreground hover:bg-muted",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
